import DataRoomMembersAccessField from './DataRoomMembersAccessField.component';

export default DataRoomMembersAccessField;
